'use strict' ;
angular.module("Khayrokom").config(['$translateProvider', function($translateProvider) {
    $translateProvider.translations("ar", {// عربي
        SELECT_LANGUAGE:"اختر اللغة",
        ARABIC:"العربية",
        ENGLISH:"English",
        MAIN: "الرئيسية",
        ABOUT_CENTER: "عن المنصة",
        STRUCTURE: "مجلس الإدارة",
        TEAM_MEMBERS:"الهيكل الإداري",
        COMMITTEE: "اللجنة الاستشارية والعلمية",
        TEACH_STUFF: "هيئة تدريس المنصة",
        WELCOME: "منصة خيركم لتعليم القرآن عن بعد",
        WELCOME_LONG: "أول منصة قرآنية توفر بيئة إلكترونية قائمة على تقنيات المعلومات والاتصالات و التعليم التفاعلي لعلوم القرآن الكريم",
        KHAYROKOM_SERV: "خدمات منصة خيركم",
        KHAYROKOM_SERV_PRO: "خدمات تعليمية قرآنية مميزة",
        KHAYROKOM_VIDS: "فيديوهات خيركم",
        MORE: "المزيد",
        KHAYROKOM_VIDS_NEW: "جديد فيديوهات خيركم",
        KHAYROKOM_NEWS: "أخبار منصة خيركم",
        KHAYROKOM_NEWS_PRO: "جديد أخبار خيركم",
        PASS_COUNT: "المجازين والمجازات",
        STUDS_COUNT: "عدد الطلاب",
        TEACH_COUNT: "المعلمين والمعلمات",
        OTL_COUNT: "التلاوات في تطبيق اتلوها صح",
        COUNTRIES_COUNT: "الدول المستفيدة",
        VISITORS_COUNT: "زوار الموقع",
        CIRCLE_DEF: "جمعية تحفيظ القرآن بجدة – خيركم – ترخيص 2/2 وزارة الشؤون الإسلامية والدعوة والإرشاد",
        PHONE_CIRCLE_MEN: "المقرأة الهاتفية الرجالية",
        PHONE_CIRCLE_WOMEN: "المقرأة الهاتفية النسائية",
        LIVE: "البث المباشر",
        CIRCLE_REQUEST: "طلب التحاق في المقارئ",
        CLASS_REQUEST: "طلب التحاق في الحلقات",
        OTLOOHA: "اتلوها صح",
        NAWARNY: "القرآن نورني",
        ENTER_SHORT: "اختصار الدخول لبرامج معينة" ,
        HALLS: "قاعات التعليم",
        CONDITIONS: "شروط الالتحاق بالبرامج والدور",
        TESTS: "نظام الاختبارات والحصول على الإجازات",
        COPYRIGHTS: "©  جميع الحقوق محفوظة لمنصة خيركم جمعية تحفيظ القراّن بجدة",
        DEVELOPER: "صمم وطُور في",
        ATRICLE_TITLE: "عنوان المقال:",
        BACK:"عودة",
        KHAYROKOM_STUFF: "الهيكل التنظيمي",
        STUFF_DESC: "تعرف على فريق العمل بالكامل",
        SERVICE_INTRO: "التعريف بالخدمة",
        SERV_JOIN_INFO: "كيفية التسجيل والالتحاق",
        WEEK_POSTS: "إصدارات الأسبوع",
        VIDEOS:"الفيديوهات",
        ENTER_SERVICE:"الدخول إلى الخدمة",
        QUERIES: "الاستفسارات",
        SEND_QUEST: "إرسال الاستفسار",
        EMAIL: "بريدك الإلكتروني",
        QUEST_HERE: "اكتب استفسارك هنا",
        INVALID_CODE: "الكود غير صحيح",
        ENTER_CODE: "أدخل كود المجموعة",
        VIDEO_TITLE: "عنوان الفيديو",
        COMMENTS: "التعليقات",
        NAME: "الاسم",
        FULLNAME: "أدخل الاسم بالكامل",
        ENTER_EMAIL: "أدخل البريد الإلكتروني",
        MSG: "الرسالة",
        MSG_TEXT: "نص الرسالة",
        SEND: "إرسال",
        TECH_ERROR: "حدث عطل فني",
        DATA_LOADED: "تم تحميل البيانات بنجاح",
        DATA_ERROR: "فشل تحميل البيانات",
        INVALID_EMAIL: "البريد الإلكتروني غير صحيح",
        ENTER_COMMENT: "اكتب التعليق",
        ABOUT_INTRO: "التعريف بمنصة خيركم لتعليم القرآن عن بعد",
        ABOUT_DESCRIPTION: "منصة قرآنية توفر بيئة قائمة على تقنيات المعلومات" +
        " والاتصالات والتعلم الإلكتروني والتعليم المدمج، وتمنح" +
        " شهادات وإجازات قرآنية وتقدم برامج وتخصصات متوائمة" +
        " مع احتياجات المجتمعات المسلمة ملبية لمتطلبات تعليم" +
        " القرآن الكريم لكافة الفئات العمرية، كما تشرف" +
        " على أي برنامج لتعليم القرآن عن بعد وفق شروط محددة.",
        VISION_TITLE: "الرؤية",
        VISION_DESC: " بيئة قرآنية إلكترونية تفاعلية ... وتعليم للمجتمعات ميسور",
        MSG_TITLE: "الرسالة",
        MSG_DESC: "تعليم القرآن الكريم لفئات المجتمع كافة من خلال خدمات تتميز بمرونتها وجودة مخرجاتها باستخدام أحدث التقنيات واستثمار الكوادر المتميزة.",
        GOALS_TITLE: "الأهداف",
        GOALS_DESC1: "- تسهيل تعليم وتحفيظ القرآن الكريم في أي وقت وأي مكان وذلك من خلال استثمار التقنية.",
        GOALS_DESC2: "- تيسير تعلم القرآن الكريم لفئات يندر فيها وجود معلمين للقرآن مثل بعض الدول الإسلامية وكذلك الأقليات المسلمة.",
        GOALS_DESC3: "- تعليم الأحكام والقواعد التجويدية وتطبيقاتها.",
        GOALS_DESC4: "- تخريج طلاب مجازين متقنين لتلاوة كتاب الله ومؤهلين للإقراء.",
        GOALS_DESC5: "- تقديم خدمة تعليم القرآن الكريم بأساليب متنوعة وبصورة مشوقة.",
        KHAYROKOM_CONSULTING:"فريق اللجنة الاستشارية والعلمية",
        CONSULTING_DESC:"تعرف علي فريق اللجنة الاستشارية و العلمية",
        LINKS:"روابط هامة",
        MOBILE_ONLY:"للجوال فقط",
        PARTNERS:"شراكات",
        COMMENTS_AND_QUESTION:"الاستفسارات و التعليقات",
        externalLink:"اضغط هنا",
        Register:'تسجيل',
        Login:'دخول'

    });
    $translateProvider.translations("en", {// انجليزي
        SELECT_LANGUAGE:"Select Language",
        ARABIC:"العربية",
        ENGLISH:"English",
        MAIN: "Main",
        ABOUT_CENTER: "About Platform",
        STRUCTURE: "Managment Board",
        TEAM_MEMBERS:"Organizational Chart",
        COMMITTEE: "Consulting Committee",
        TEACH_STUFF: "Teaching Stuff",
        WELCOME: "Khayrokom Supervision Platform",
        WELCOME_LONG: "Welcome to Supervision Platform for distance learning. We are a Quran platform providing an IT/Communication based environment. Texts depicting platform definition.",
        KHAYROKOM_SERV: "Khayrokom Services",
        KHAYROKOM_SERV_PRO: "Premium Khayrokom Services",
        KHAYROKOM_VIDS: "Khayrokom Videos",
        MORE: "More",
        KHAYROKOM_VIDS_NEW: "Recent Khayrokom Videos",
        KHAYROKOM_NEWS: "Khayrokom News",
        KHAYROKOM_NEWS_PRO: "Recent Khayrokom News",
        PASS_COUNT: "Passed Students",
        STUDS_COUNT: "Student Count",
        TEACH_COUNT: "Teacher Count",
        OTL_COUNT: "Otlooha Sah App Recitations",
        COUNTRIES_COUNT: "Affected Countries",
        VISITORS_COUNT: "Visitors Count",
        CIRCLE_DEF: "Khayrokom association for Quran recitation in Jeddah, license 2/2 from Ministry of Islamic Affairs and Guidance",
        PHONE_CIRCLE_MEN: "Men Phone Circle",
        PHONE_CIRCLE_WOMEN: "Women Phone Circle",
        LIVE: "Live Streaming",
        CIRCLE_REQUEST: "Circle Join Request",
        CLASS_REQUEST: "Class Join Request",
        OTLOOHA: "Recite It Right",
        NAWARNY: "Quran Enlightened Me",
        ENTER_SHORT: "Programs Quick Login",
        HALLS: "Learning Halls",
        CONDITIONS: "Programs Join Conditions",
        TESTS: "Tests and Certificates Terms",
        COPYRIGHTS: "All rights are reserved to Khayrokom platform for Quran Learning in Jeddah ©",
        DEVELOPER: "Designed and Developed by",
        ATRICLE_TITLE: "Atricle Title:",
        BACK:"Back",
        KHAYROKOM_STUFF: "Khayrokom Team",
        STUFF_DESC: "Know about all the team",
        SERVICE_INTRO: "Service Description",
        SERV_JOIN_INFO: "How to Join?",
        WEEK_POSTS: "Week Posts",
        VIDEOS:"Videos",
        ENTER_SERVICE:"Join Service",
        QUERIES: "Questions",
        SEND_QUEST: "Send Question",
        EMAIL: "Your Email",
        QUEST_HERE: "Type your question here",
        INVALID_CODE: "Invalid Code",
        ENTER_CODE: "Enter Group Code",
        VIDEO_TITLE: "Video Title",
        COMMENTS: "Comments",
        NAME: "Name",
        FULLNAME: "Enter Full Name",
        ENTER_EMAIL: "Enter Email",
        MSG: "Message",
        MSG_TEXT: "Message Text",
        SEND: "Send",
        TECH_ERROR: "A Technical Error happened",
        DATA_LOADED: "Data Loaded Successfully",
        DATA_ERROR: "Data Failed to Load",
        INVALID_EMAIL: "Invalid Email",
        ENTER_COMMENT: "Type Comment",
        ABOUT_INTRO: "About Supervision Platform For Distance Learning",
        ABOUT_DESCRIPTION: "A Quran platform provides an environment which is based on IT/communications, e-learning and blended learning. " +
        "It provides Quran certificates as well as programs and majors that are suitable to Muslim societies needs, " +
        "satisfying Quran education needs for all age groups. " +
        "It also adminstrates any program for Quran distance learning based on pre-specified conditions.",
        VISION_TITLE: "Vision",
        VISION_DESC: "A Quran online interactive environment ... with convenient education for societies.",
        MSG_TITLE: "Message",
        MSG_DESC: "Quran education for all society groups through services known for flexibility and outcomes quality, via most recent technologies as well as utilizing well-trained stuff.",
        GOALS_TITLE: "Goals",
        GOALS_DESC1: "- Facilitating Quran learning at any time or place using IT/communications technologies.",
        GOALS_DESC2: "- Facilitating learning Quran for groups who can't get Quran teachers easily, such as some Muslim countries and Muslim minorities.",
        GOALS_DESC3: "- Teaching Recitation rules and their applications.",
        GOALS_DESC4: "- Graduating certified students who excel Quran Recitation and are qualified for teaching more students.",
        GOALS_DESC5: "- Providing Quran education services using diverse methods and exciting manners.",
        KHAYROKOM_CONSULTING:"Consulting Committee Team",
        CONSULTING_DESC:"Know about our Consulting committee team",
        LINKS:"Feature Links",
        MOBILE_ONLY:"Mobile Only",
        PARTNERS:"Partners",
        COMMENTS_AND_QUESTION:"Inquiries and Comments",
        externalLink:"Cick Here"
    });
    $translateProvider.preferredLanguage("ar");
    $translateProvider.useSanitizeValueStrategy('escape');
}]);


// WEBPACK FOOTER //
// ./js/app/translate.js